import { } from '@/api/requests';
import router from '../../router';

const state = {
  selectedUser: {},
  selectedReport: {},
  viewReportDetails: false,
};

const mutations = {
  setSelectedUser(state, user) {
    state.selectedUser = user;
  },

  clearSelectedUser(state) {
    state.selectUser = {};
  },

  setSelectedReport(state, report) {
    state.selectedReport = report;
    state.viewReportDetails = true;
  },

  clearSelectedReport(state) {
    state.selectedReport = {};
    state.viewReportDetails = false;
  }
};

const actions = {
  selectUser(context, user) {
    context.commit('setSelectedUser', user);
  },

  closeUserPage(context) {
    context.commit('clearSelectedUser');
  },

  reportClicked(context, report) {
    context.commit('setSelectedReport', report);
  },

  reportDetailsClosed(context) {
    context.commit('clearSelectedReport');
  }
};

const getters = {

};

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};